import dynamic from 'next/dynamic'
import { ReactNode, useState } from 'react'

const Drawer = dynamic(() => import('../components/DrawerV2'), {
  ssr: false
})

type OperationsConfig = {
  [k: string]: {
    title: string
    component: React.ElementType
  }
}

export type UseOperationsDrawerCloseHandler = (operation: string) => void
export type UseOperationsDrawerOpenHandler<P> = (
  operation: string,
  operationProps?: P
) => void

type UseOperationsDrawerReturn<P> = {
  closeOperation: UseOperationsDrawerCloseHandler
  openOperation: UseOperationsDrawerOpenHandler<P>
  operationDrawer: ReactNode
}

type UseOperationsDrawer = <P>(
  operationsConfig: OperationsConfig
) => UseOperationsDrawerReturn<P>

/**
 * use an operations drawer by passing down the operations it should support
 */
const useOperationsDrawer: UseOperationsDrawer = function (operations) {
  const [opened, setOpened] = useState(false)
  const [openedOperation, setOpenedOperation] = useState()
  const [operationProps, setOperationProps] = useState({})

  const openOperation = function (operation, _operationProps) {
    if (Object.keys(operations).includes(operation)) {
      setOpened(true)
      setOpenedOperation(operation)
      if (_operationProps) {
        setOperationProps(_operationProps)
      }
    }
  }
  const closeOperation = function (operation) {
    if (Object.keys(operations).includes(operation)) {
      setOpened(false)
      setOpenedOperation(undefined)
    }
  }

  const OperationComponent = openedOperation
    ? operations[openedOperation].component
    : null
  const title = openedOperation && operations[openedOperation].title

  return {
    closeOperation,
    openOperation,
    operationDrawer: (
      <Drawer
        initialOpened={opened}
        onClose={() => setOpened(false)}
        showClose
        title={title}
      >
        {OperationComponent && <OperationComponent {...operationProps} />}
      </Drawer>
    )
  }
}

export default useOperationsDrawer
